import React from "react";
import { Box, Typography, Button, Divider, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import CartItemActions from "./CartItemActions";
import { useSelector } from "react-redux";
import { calculateOrderDiscountSummary } from "../helpers/orderDiscountHelper";
import {
  getUnitPrice,
  calculateItemTotal,
} from "../helpers/cartPriceHelper";

export default function CartHoverPreview({ cart = [] }) {
  const navigate = useNavigate();
  const loggedUser = useSelector(
    (state) => state.user.logedUser
  );

  const orderForCalculation = {
    ordersProducts: cart,
    user: loggedUser,
  };

  const priceSummary =
    calculateOrderDiscountSummary(
      orderForCalculation
    );

  const total = priceSummary.finalTotal;

  const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";

  const resolveImgSrc = (img) => {
    if (!img) return "";
    const path = String(img).replace(/\\/g, "/");

    if (path.startsWith("http") || path.startsWith("//")) {
      return path;
    }

    return `${API_BASE}${path}`;
  };



  return (
    <Box
      sx={{
        width: 380,
        bgcolor: "white",
        boxShadow: 4,
        border: "1px solid #ddd",
        zIndex: 9999,
        p: 2,
        direction: "rtl",
      }}
    >
      {cart.length === 0 ? (
        <Typography textAlign="center" py={4}>
          אין מוצרים בעגלה
        </Typography>
      ) : (
        <>
          <Box
            sx={{
              maxHeight: 195,
              overflowY: cart.length > 3 ? "auto" : "visible",
            }}
          >
            {cart.map((item) => {
              const product = item.product;
              const displayImage = item.productOption?.image || product?.image;
              const unitPrice = getUnitPrice(item);
              const lineTotal = calculateItemTotal(item);

              return (
                <Box key={item.id}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "50px 1fr 110px",
                      alignItems: "center",
                      gap: 1,
                      py: 1,
                    }}
                  >
                    <Box
                      component="img"
                      src={resolveImgSrc(displayImage)}
                      alt={product?.name || ""}
                      sx={{
                        width: 45,
                        height: 45,
                        objectFit: "cover",
                        border: "1px solid #eee",
                      }}
                    />

                    <Box>
                      <Typography fontSize={14} fontWeight={600}>
                        {product?.name}
                      </Typography>

                      {item.productOption && (
                        <Typography fontSize={13}>
                          {item.productOption.optionType === "Color"
                            ? "צבע"
                            : "בחירה"}
                          : {item.productOption.value}
                        </Typography>
                      )}

                      <Typography fontSize={13}>
                        {item.amount} ×  {unitPrice.toFixed(2)} ₪
                      </Typography>
                    </Box>

                    <CartItemActions item={item} product={product} variant="preview" />
                  </Box>

                  <Divider />
                </Box>
              );
            })}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Typography fontWeight={600}>
              סה״כ: {total.toFixed(2)}  ₪
            </Typography>

            <Button
              variant="contained"
              sx={{ backgroundColor: "#D81B60" }}
              onClick={() => navigate("/cart")}
            >
              לעגלה
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}